/* eslint-disable react/destructuring-assignment */
import React from "react";
import { bool, string } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import FormattedDate from "pages/_components/FormattedDate";

const DataDetailThirdParties = (props) => {
    const {
        paymentType = props.paymentType,
        debitAccount = props.debitAccount,
        prosesDate = props.prosesDate,
        paymentOrders = props.paymentOrders,
        totalAmont = props.totalAmont,
        currency = props.currency,
        isDesktop = props.isDesktop,
    } = props;
    return (
        <>
            <GridTable className="details debin-credin-list">
                <GridTable.Container columns={3} rows={2}>
                    <GridTable.Data columnStart={1} rowStart={1} columnWidth={1}>
                        <CustomData
                            titleText="payments.newPayment.typePayment.label"
                            titleTextType="I18N"
                            valueText={paymentType}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 1 : 2} columnWidth={1}>
                        <CustomData
                            titleText="payThirdParties.account.label"
                            titleTextType="I18N"
                            valueText={debitAccount}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 3} columnWidth={1}>
                        <CustomData
                            titleText="payments.newPayment.datePayment.label"
                            titleTextType="I18N"
                            valueText={<FormattedDate date={prosesDate} dateFormat="DD/MM/YYYY HH:mm:ss" />}
                        />
                    </GridTable.Data>

                    <GridTable.Data columnStart={1} rowStart={isDesktop ? 2 : 4} columnWidth={1}>
                        <CustomData
                            titleText="payments.newPayment.linesNumber.label"
                            titleTextType="I18N"
                            valueText={paymentOrders}
                        />
                    </GridTable.Data>
                    <GridTable.Data columnStart={isDesktop ? 2 : 1} rowStart={isDesktop ? 2 : 5} columnWidth={1}>
                        <CustomData
                            titleText="payThirdParties.totalAmount.label"
                            titleTextType="I18N"
                            valueText={<FormattedAmount currency={currency} quantity={totalAmont} />}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>
        </>
    );
};

DataDetailThirdParties.propTypes = {
    paymentType: string,
    debitAccount: string,
    prosesDate: string,
    paymentOrders: string,
    totalAmont: string,
    currency: string,
    isDesktop: bool,
};

DataDetailThirdParties.defaultProps = {
    paymentType: "",
    debitAccount: "",
    prosesDate: "",
    paymentOrders: "",
    totalAmont: "",
    currency: "",
    isDesktop: true,
};

export default DataDetailThirdParties;
